import { Player } from "@lottiefiles/react-lottie-player";
import classNames from "classnames";
import React, { FunctionComponent, useRef } from "react";
import { getVariableByEnv } from "../../../utils/variableByEnv";
import animation from "./loader-custo.json";
import xmasAnimation from "./loader-xmas.json";
import "./style.scss";

interface Props {
  fullPage?: boolean;
  loaded?: boolean;
}

const PageLoader: FunctionComponent<Props> = ({ fullPage, loaded }) => {
  const playerRef = useRef<Player>(null);

  const isChristmasTime = getVariableByEnv("REACT_APP_CHRISTMAS_ANIMATION") === "true";

  return (
    <div
      className={classNames("PageLoader", {
        "PageLoader--fullPage": fullPage,
        "PageLoader--loaded": loaded,
      })}
    >
      <Player
        autoplay={true}
        loop={true}
        ref={playerRef}
        renderer="svg"
        src={isChristmasTime ? xmasAnimation : animation}
        style={{
          height: "157px",
          width: "220px",
        }}
      ></Player>
    </div>
  );
};

export default PageLoader;
